import { Link } from "react-router-dom";
import constants from "../constants/constants";
import calculatorImage from "../assets/images/calculator-bg.jpg"
import reportsImage from "../assets/images/reports-bg.jpg"
import evaluationImage from "../assets/images/evaluation-bg.jpg"

export default function Tools() {
  return (
    <section className="py-16">
      <h1 className="text-4xl text-black py-8 font-mont text-center mt-6">
        USEFUL TOOLS
      </h1>
      <div className="grid md:grid-cols-3 gap-10 child:overflow-hidden max-w-[1100px] mx-auto px-7 mb-10">
        <Link to="/calculator">
          <div className="overflow-hidden h-96 relative">
            <img
              className="h-full w-full object-cover"
              src={calculatorImage}
              alt="Mortgage Calculator"
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            {constants.CALCULATOR_TITLE}
          </h3>
          <span className="font-mont">{constants.CALCULATOR_SUBTITLE}</span>
        </Link>
        <Link to="/real-estate-reports">
          <div className="overflow-hidden h-96 relative">
            <img
              className="h-full w-full object-cover"
              src={reportsImage}
              alt="Real Estate Reports"
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            {constants.REPORTS_TITLE}
          </h3>
          <span className="font-mont">{constants.REPORTS_SUBTITLE}</span>
        </Link>
        <Link to="/evaluation">
          <div className="overflow-hidden h-96 relative">
            <img
              className="h-full w-full object-cover"
              src={evaluationImage}
              alt="Home Evaluation"
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          </div>
          <h3 className="text-2xl text-black pt-5 pb-2 font-mont">
            {constants.EVALUATION_TITLE}
          </h3>
          <span className="font-mont">{constants.EVALUATION_SUBTITLE}</span>
        </Link>
      </div>
    </section>
  );
}
